import React from 'react';
import './Styles/Banner.scss';
import profile from '../../../Assets/Cards/authorProfile.png';
import {FaFacebookF , FaTwitter} from 'react-icons/fa';
import {AiOutlineInstagram , AiFillYoutube} from 'react-icons/ai';
export const icons = [
  <FaFacebookF /> , <FaTwitter />, <AiOutlineInstagram />,<AiFillYoutube />
]
const Banner=()=>{
    return(
        <div className="author-banner">
          <img src={profile} />
          <h1>Liz Steelman</h1>
          <div className="icons">
            {icons.map((icon) =>{
              return(
              <div className="circle">
                <div className="icon">
                  {icon}
                  </div>
              </div>
              )
            })}
          </div>
        </div>
    )
};
export default Banner ;